'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _swaggerUi = require('swagger-ui');

var _swaggerUi2 = _interopRequireDefault(_swaggerUi);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _OperationSummary2 = require('./OperationSummary');

var _OperationSummary3 = _interopRequireDefault(_OperationSummary2);

var _OperationActions = require('./OperationActions');

var _OperationActions2 = _interopRequireDefault(_OperationActions);

var _Examples = require('./Examples');

var _Examples2 = _interopRequireDefault(_Examples);

var _CodeExampleCurl = require('./CodeExampleCurl');

var _CodeExampleCurl2 = _interopRequireDefault(_CodeExampleCurl);

var _CodeExampleNodeJS = require('./CodeExampleNodeJS');

var _CodeExampleNodeJS2 = _interopRequireDefault(_CodeExampleNodeJS);

var _CodeExampleWebJS = require('./CodeExampleWebJS');

var _CodeExampleWebJS2 = _interopRequireDefault(_CodeExampleWebJS);

var _CodeExampleTitanium = require('./CodeExampleTitanium');

var _CodeExampleTitanium2 = _interopRequireDefault(_CodeExampleTitanium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A convenience wrapper around swagger-ui that supports the following features:
 *
 * * A boolean `showInfo` to hide/show Info panel.
 * * A boolean `authorization` to hide/show the AuthorizationButton (lock) and
 *   the schemes container.  They work together, so are toggled together.
 * * Better code examples, replacing the `curl` component with: curl, Node.js,
 *   WebJS, and Titanium.  Additional code examples can also be provided.
 */
var OpenAPI = function (_React$Component) {
	_inherits(OpenAPI, _React$Component);

	function OpenAPI() {
		_classCallCheck(this, OpenAPI);

		return _possibleConstructorReturn(this, (OpenAPI.__proto__ || Object.getPrototypeOf(OpenAPI)).apply(this, arguments));
	}

	_createClass(OpenAPI, [{
		key: 'toSwaggerUIProps',

		/**
   * Converts OpenAPI props to the props format used by the internal
   * SwaggerUI component.
   */
		value: function toSwaggerUIProps() {
			// pull out our own props
			var _props = this.props,
			    showInfo = _props.showInfo,
			    authorization = _props.authorization,
			    plugins = _props.plugins,
			    additionalProps = _objectWithoutProperties(_props, ['showInfo', 'authorization', 'plugins']);

			var propsToDelete = ['oauthConfig', 'apiKeyConfig', 'httpConfig', 'className'];

			propsToDelete.forEach(function (key) {
				return delete additionalProps[key];
			});

			return _extends({}, additionalProps, {
				plugins: [
				// These default plugins are functionally equivalent to the originals.
				// The `OperationSummary` allows additional UI "actions" to be added
				// to the method summary.  The `Examples` replaces the `curl` plugin
				// and is itself pluggable and configurable.
				function () {
					return {
						wrapComponents: {
							OperationSummary: function OperationSummary() {
								return _OperationSummary3.default;
							},
							curl: _Examples2.default,
							info: function info(Original) {
								return function (props) {
									return showInfo ? _react2.default.createElement(Original, props) : null;
								};
							},
							authorizeOperationBtn: function authorizeOperationBtn(Original) {
								return function (props) {
									return authorization ? _react2.default.createElement(Original, props) : null;
								};
							}
						},
						components: {
							OperationActions: _OperationActions2.default,
							CodeExampleCurl: _CodeExampleCurl2.default,
							CodeExampleNodeJS: _CodeExampleNodeJS2.default,
							CodeExampleWebJS: _CodeExampleWebJS2.default,
							CodeExampleTitanium: _CodeExampleTitanium2.default
						}
					};
				}].concat(_toConsumableArray(plugins || []))
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    className = _props2.className,
			    authorization = _props2.authorization,
			    oauthConfig = _props2.oauthConfig,
			    apiKeyConfig = _props2.apiKeyConfig,
			    httpConfig = _props2.httpConfig;


			var SwaggerUIComponent = (0, _swaggerUi2.default)(this.toSwaggerUIProps());

			if (oauthConfig) {
				// Optionally configure OAuth
				SwaggerUIComponent.initOAuth(oauthConfig);
			}

			if (apiKeyConfig) {
				SwaggerUIComponent.preauthorizeApiKey(apiKeyConfig.definitionKey, apiKeyConfig.value);
			}

			if (httpConfig) {
				SwaggerUIComponent.preauthorizeBasic(httpConfig.definitionKey, httpConfig.username, httpConfig.password);
			}

			SwaggerUIComponent = SwaggerUIComponent.getComponent('App', 'root');

			var classes = (0, _classnames2.default)('openapi', 'oas-swagger-ui', className, { 'hide-scheme-container': !authorization });

			return _react2.default.createElement(
				'div',
				{ className: classes },
				_react2.default.createElement(SwaggerUIComponent, null)
			);
		}
	}]);

	return OpenAPI;
}(_react2.default.Component);

OpenAPI.propTypes = {
	/**
  * The OpenAPI spec, 2.x or 3.x.
  */
	spec: _propTypes2.default.object,
	/**
  * Additional swagger-ui plugins to provide.  These are appended with the
  * the default ones provided by this component.
  */
	plugins: _propTypes2.default.arrayOf(_propTypes2.default.func),
	/**
  * Controls operation authorization button.  When enabled, this will show
  * schemes and the authorize operation button (lock-icon).  The two are
  * related.
  */
	authorization: _propTypes2.default.bool,
	/**
  * Disables the 'Info' panel
  */
	showInfo: _propTypes2.default.bool,
	/**
  * Array of examples by key name.  The built in names are: curl, node, web,
  * and titanium.  Custom examples can be provided by included an object as
  * per the shape below.  If more than one example provided, the examples
  * will be enclosed in tabs.
  */
	examples: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
		component: _propTypes2.default.string.isRequired,
		comment: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string.isRequired,
		generate: _propTypes2.default.func.isRequired
	})])),
	/**
  * The layout to use if an alternative is specified as a plugin.
  */
	layout: _propTypes2.default.string,
	/**
  * A request interceptor
  */
	requestInterceptor: _propTypes2.default.func,
	/**
  * A response interceptor
  */
	responseInterceptor: _propTypes2.default.func,
	/**
  * Initialization object for OAuth
  * see https://github.com/swagger-api/swagger-ui/blob/v3.24.3/docs/usage/oauth2.md
  */
	oauthConfig: _propTypes2.default.shape({
		clientId: _propTypes2.default.string,
		clientSecret: _propTypes2.default.string,
		realm: _propTypes2.default.string,
		appName: _propTypes2.default.string,
		scopeSeperator: _propTypes2.default.string,
		additionalQueryStringParams: _propTypes2.default.object,
		useBasicAuthenticationWithAccessCodeGrant: _propTypes2.default.bool,
		usePkceWithAuthorizationCodeGrant: _propTypes2.default.bool
	}),
	/**
  * Initialization object for API Key
  * see https://github.com/swagger-api/swagger-ui/blob/master/docs/usage/configuration.md#instance-methods
  */
	apiKeyConfig: _propTypes2.default.shape({
		definitionKey: _propTypes2.default.string,
		value: _propTypes2.default.string
	}),
	/**
  * @see https://github.com/swagger-api/swagger-ui/blob/master/docs/usage/configuration.md#instance-methods
  */
	httpConfig: _propTypes2.default.shape({
		definitionKey: _propTypes2.default.string,
		username: _propTypes2.default.string,
		password: _propTypes2.default.string
	})
};

OpenAPI.defaultProps = {
	authorization: false,
	showInfo: false,
	examples: ['curl', 'node', 'titanium', 'web']
};

var _default = OpenAPI;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(OpenAPI, 'OpenAPI', 'src/components/OpenAPI/OpenAPI.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/OpenAPI.jsx');
}();

;